import moment from "moment";
import ReactDatePicker from "react-datepicker"

interface IQuarterCalendarProps {
  startDate: Date | null | undefined;
  endDate: Date | null | undefined;
  onChange: (date: [Date | null, Date | null]) => void;
}

const QuarterContent = (quarter: number, shortQuarterText: string) => {
  return <div className="px-2 py-2 box-border">{shortQuarterText}</div>;
};

export const QuarterCalendar = ({ startDate, endDate, onChange}: IQuarterCalendarProps) => {
  return (
    <ReactDatePicker
      selected={startDate}
      onChange={(date) => {
        const start = moment(date).toDate();
        const end = moment(date).endOf('quarter').toDate();
        onChange([start, end])
      }}
      calendarStartDay={1}
      startDate={startDate}
      endDate={endDate}
      calendarClassName="!border-0"
      inline
      disabledKeyboardNavigation
      showQuarterYearPicker={true}
      renderQuarterContent={QuarterContent}
    />
  )
}